import { render, staticRenderFns } from "./modal-board-save.vue?vue&type=template&id=146e0328&"
import script from "./modal-board-save.vue?vue&type=script&lang=js&"
export * from "./modal-board-save.vue?vue&type=script&lang=js&"
import style0 from "./modal-board-save.vue?vue&type=style&index=0&id=146e0328&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports